import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditPromoCode = (props) => {
  const { promoCodeId } = props.params

  return (
    <Edit
      title='Edit Promo Code'
      fields={fields}
      apiPath={`admin/promo_codes/${promoCodeId}`}
      successRedirectPath='/ecommerce/promo-codes'
      buildMenuItems={menuItems}
    />
  )
}

export default EditPromoCode
